import {Component, Input, OnInit} from '@angular/core';
import { Animations } from '../../../animations';

@Component({
  selector: 'app-slide-panel',
  templateUrl: './slide-panel.component.html',
  styleUrls: ['./slide-panel.component.less'],
  animations: Animations
})
export class SlidePanelComponent implements OnInit {
  @Input() counter = -1;
  @Input() upperText = '';
  @Input() title = '';

  isShowing = false;

  toggleItemsVisibility(): void {
    this.isShowing = !this.isShowing;
  }

  constructor() { }

  ngOnInit(): void {}

}
